import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppService } from 'src/@core/services/app.service';
import { AuthService } from 'src/@core/services/auth.service';
import { JobService } from 'src/@core/services/job/job.service';
import { NotificationService } from 'src/@core/services/notification.service';
import { TwilioService } from 'src/@core/services/twilio.service';
import { EnterpriseAdminService } from 'src/app/modules/enterprise-admin/enterprise-admin.service';
import logoLinkedIn from '@iconify/icons-logos/linkedin';
import logoGitHub from '@iconify/icons-logos/github';
import logoTwitter from '@iconify/icons-logos/twitter';
import logoFacebook from '@iconify/icons-logos/facebook';
import { MatDialog } from '@angular/material';
import { WorkflowPopupComponent } from '../../workflow-popup/workflow-popup.component';


@Component({
  selector: 'hour4u-admin-view-project-details',
  templateUrl: './view-project-details.component.html',
  styleUrls: ['./view-project-details.component.scss']
})
export class ViewProjectDetailsComponent implements OnInit {
  @Input() callData?: any = null;
  @Input() refreshTrigger: number;
  @Input() projectDetails: any;
  @Input() pageIndex?: number = 1;
  @Input() pageSize?: number = 10;
  @Input() pageSizeOptions?: number[] = [10, 20, 50, 100, 200];
  @Input() currentRange?: string = '';
  @Input() hideCallButton: boolean = false;
  @Input() hideExtraColumns: boolean = false;
  @Output() pageChange = new EventEmitter<{ pageNum: number; pageSize: number }>();

  selection = new SelectionModel<any>(true, []);
  dataSource = [];
  allRowsSelected: boolean = false;
  profile = this.appService.getCurrentAccount();
  private intervalId: any;
  diameter = 40;
  loaderColor: string;
  mode = 'indeterminate';
  isLoading: boolean = false;
  currentAudio: HTMLAudioElement | null = null;
  playingRecordingId: string | null = null;
  // pageIndex = 1;
  // pageSize = 10;
  pagination: any;
  // currentRange: string = '';
  //   pageSizeOptions: number[] = [10, 20, 50, 100, 200, 500];
  isExporting: boolean = false;
  currentRecordingUrl: string | null = null;
  metadata: any;

  logoLinkedIn = logoLinkedIn;
  logoGitHub = logoGitHub;
  logoTwitter = logoTwitter;
  logoFacebook = logoFacebook;

  showEmploymentModal = false;
  selectedEmploymentHistory: any[] = [];

  constructor(
    private appService: AppService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private notify: NotificationService,
    public enterpriseAdminService: EnterpriseAdminService,
    private twilioService: TwilioService,
    private jobService: JobService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    console.log("call data", this.projectDetails, this.hideCallButton)
    this.route.params.subscribe(data => {
      console.log("param data", this.callData)
      //this.getProjectById(this.profile.entity.id, data.id)
      //this.getCurrentRole();
      //this.ctaSet();
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.isLoading = true;
    if (changes['callData'] && changes['callData'].currentValue) {
      this.isLoading = false;
      const callData = changes['callData'].currentValue;
      this.dataSource = callData.records;
      this.pagination = callData.pagination;
      this.updateRange();
      console.log("callData and pagination received in child component:", this.dataSource, this.pagination);
    } else {
      this.isLoading = false;
    }
    if (changes['projectDetails'] && changes['projectDetails'].currentValue) {
      console.log("Received projectDetails in child component:", this.projectDetails);
    }
  }

  // Select all rows 
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.length;
    return numSelected === numRows;
  }

  masterToggle(event: any) {
    if (event.checked) {
      this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.forEach(row => { this.selection.select(row) });
      this.isAllSelected() ? this.allRowsSelected = true : this.allRowsSelected = false;
    } else {
      this.selection.clear();
    }
  }

  callSelectedAllUsers() {
    console.log(this.selection, this.projectDetails)
    let callObj = [];
    if (this.selection && this.selection.selected.length) {
      this.selection.selected.forEach(element => {
        let obj = {
          "client_name": element.client_name,
          "client_email": element.client_email,
          "client_number": element.client_number,
          "entity_id": this.profile.entity.id,
          "tts": "elevenlabs",
          "language": this.projectDetails.language || "en",
          "voice": this.projectDetails.voice || "male",
        }
        callObj.push(obj);
      });

      this.enterpriseAdminService.callSelectedUsers(this.projectDetails.agent_id, this.projectDetails.project_id, this.projectDetails.entity_id, callObj).subscribe(res => {
        this.notify.showMessage(
          `Connecting users...`,
          30000
        );
        // No empty status-polling interval
      }, (err => {
        console.log(err)
      }))
    } else {
      this.notify.showMessage(
        `Please select users first!`,
        30000
      );
    }
  }

  getUpdatingStatus(job_id) {
    this.enterpriseAdminService.getUpdatedStatus(job_id, this.profile.entity.id,).subscribe(res => {

    }, (err => {
      console.log(err)
    }))
  }

  exportData() {

  }

  onNext() {
    if (this.pagination && this.pagination.currentPageNum < this.pagination.totalPages) {
      this.pagination.currentPageNum += 1;
      this.pageChange.emit({
        pageNum: this.pagination.currentPageNum,
        pageSize: this.pagination.maxPageSize,
      });
    }
  }

  onPrev() {
    if (this.pagination && this.pagination.currentPageNum > 1) {
      this.pagination.currentPageNum -= 1;
      this.pageChange.emit({
        pageNum: this.pagination.currentPageNum,
        pageSize: this.pagination.maxPageSize,
      });
    }
  }

  updateRange() {
    if (this.pagination && this.pagination.currentPageNum && this.pagination.currentPageSize && this.pagination.totalElements) {
      const start = (this.pagination.currentPageNum - 1) * this.pagination.currentPageSize + 1;
      const end = Math.min(this.pagination.currentPageNum * this.pagination.currentPageSize, this.pagination.totalElements);
      this.currentRange = `${start} - ${end} of ${this.pagination.totalElements} records`;
    } else {
      this.currentRange = '0 - 0 of 0 records'; // Default value in case pagination is not valid
    }
  }

  onPageSizeChange(value: any) {
    const newSize = parseInt(value, 10);
    this.pageSize = newSize;
    this.pagination.currentPageSize = this.pageSize;
    this.pagination.currentPageNum = 1; // Reset to the first page after size change
    this.updateRange();
    this.pageChange.emit({
      pageNum: this.pagination.currentPageNum,
      pageSize: this.pagination.currentPageSize,
    });
  }

  triggerParentPagination() {
    // Emit an event to parent or update callData directly (depending on your setup)
    console.log("Pagination triggered for page:", this.pageIndex);
  }

  // Fetch and set recording URL for the audio player
  openRecording(callSid: string) {
    console.log(callSid)
    // Stop current audio if a new row is clicked
    if (this.playingRecordingId && this.playingRecordingId !== callSid) {
      this.stopRecording();
    }

    // Toggle playback if the same row is clicked again
    if (this.playingRecordingId === callSid) {
      this.stopRecording();
      return;
    }

    // Fetch the recording URL and play
    this.twilioService.getCallRecordings(callSid)
      .then((mediaUrl: string | null) => {
        if (mediaUrl) {
          this.playRecording(callSid, mediaUrl);
        } else {
          console.log('No recordings found for this call');
        }
      })
      .catch(error => console.error('Error fetching recording:', error));
  }
  stopRecording() {
    if (this.currentAudio) {
      this.currentAudio.pause();
      this.currentAudio.currentTime = 0;
      this.currentAudio = null;
      this.playingRecordingId = null;
      this.currentRecordingUrl = null;
    }
  }
  playRecording(callSid: string, audioUrl: string) {
    // If the same recording is clicked, toggle play/pause
    if (this.playingRecordingId === callSid && this.currentAudio) {
      if (this.currentAudio.paused) {
        this.currentAudio.play();
      } else {
        this.currentAudio.pause();
      }
      return;
    }

    // Stop current audio if a different row is clicked
    if (this.currentAudio && this.playingRecordingId !== callSid) {
      this.currentAudio.pause();
      this.currentAudio.currentTime = 0;
    }

    // Create a new audio element for the selected recording
    this.currentAudio = new Audio(audioUrl);
    this.playingRecordingId = callSid;
    this.currentRecordingUrl = audioUrl;

    // Play the audio
    this.currentAudio.play();
  }

  openEmploymentModal(employmentHistory: any[]) {
    this.selectedEmploymentHistory = employmentHistory || [];
    this.showEmploymentModal = true;
  }

  closeEmploymentModal() {
    this.showEmploymentModal = false;
  }

  formatDate(dateString: string | null): string {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short' }); // e.g., "Jun 2022"
  }

  revealContact(type: 'phone' | 'email', call: any) {
    console.log(`Revealing ${type} for`, call);
    const people_id = call.people_id;
    const project_id = call.project_id;

    if (!call.public_profiles.linkedin) {
      console.error('No LinkedIn URL available for this candidate.');
      return;
    }

    this.enterpriseAdminService.fetchCandidatePersonalDetails(call.public_profiles.linkedin, type, people_id, project_id).subscribe(
      (response: any) => {
        if (type === 'phone') {
          call.client_number = response.phone_number || 'Fetching number...';
        } else {
          call.client_email = response.email || 'Fetching email...';
        }
      },
      (error) => {
        console.error('Error fetching candidate details:', error);
      }
    );
  }

  openWorkflowPopup() {
    const dialogRef = this.dialog.open(WorkflowPopupComponent, {
      width: '640px',
      panelClass: 'add-edit-staff-dialog',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
}
